export const labels = {
  sv: {
    booking: {
      nav: 'Bokningssteg',
      guests: 'Steg 1: Gäster',
      date: 'Steg 2: Datum',
      time: 'Steg 3: Tid',
      summary: 'Bokningsöversikt',
      edit: 'Redigera bokning',
      view: 'Visa bokning på',
    },
    quickEditTabs: {
      seatings: 'Antal gäster',
      date: 'Datum',
      time: 'Tid',
    },
    counter: {
      group: {
        default: 'Val av antal gäster',
        kids: 'Val av antal barn',
        time: 'Val av tid',
      },
      button: {
        decrease: 'Minska antal gäster',
        increase: 'Öka antal gäster',
        decreaseKids: 'Minska antal barn',
        increaseKids: 'Öka antal barn',
        decreaseTime: 'Välj en tidigare tid',
        increaseTime: 'Välj en senare tid',
      },
      numberOfVisitors: {
        label: 'Antal gäster',
      },
      numberOfKids: {
        label: 'Antal barn',
      },
    },
    calendar: {
      navigation: 'Kalendernavigation',
      previousYear: 'Föregående år',
      nextYear: 'Nästa år',
      previousMonth: 'Föregående månad',
      nextMonth: 'Nästa månad',
      year: 'År',
      month: 'Månad',
      day: 'Dag',
      selected: 'Valt datum',
      today: 'Idag',
      disabled: 'Ej tillgängligt datum',
      event: 'Evenemangsdatum',
      datePicker: 'Datumväljare',
      tableCaption: 'Kalendertabell för',
    },
    timeSlots: {
      group: 'Tider för {0}',
      selection: 'Tidsval',
      suggestion: 'Föreslagna tider',
    },
    datePicker: {
      dialog: 'Välj datum',
    },
    timePicker: {
      dialog: 'Välj tid',
    },
    segmentedControl: {
      default: 'Val av sittplats inne eller ute',
      indoor: 'Inomhus',
      outdoor: 'Utomhus',
    },
    reservation: {
      header: {
        title: {
          waitlist: 'Väntelista',
        },
      },
    },
    relatedVenues: {
      title: 'Lediga tider på',
    },
    waitlist: {
      accept: {
        message: {
          close: 'Stäng dialogruta',
        },
        availableSlots: 'Lediga tider',
      },
    },
    background: {
      decoration: 'Bakgrundsdekoration',
    },
    reservationPhase: {
      label: {
        started: 'Pågår',
        seated: 'Pågår',
        completed: 'Tidigare bokning',
        cancelled: 'Avbokad',
        declined: 'Nekad',
        expired: 'Utgången',
      },
      notice: {
        started: 'Din bokade tid har börjat, så bokningen kan inte längre ändras eller avbokas här. Kontakta restaurangen om du behöver hjälp.',
        seated: 'Du har fått ditt bord – njut av besöket! Bokningen kan inte längre ändras eller avbokas.',
        completed: 'Den här bokningen har redan ägt rum. Välkommen tillbaka!',
        cancelled: 'Den här bokningen är avbokad.',
        declined: 'Restaurangen kunde tyvärr inte ta emot den här förfrågan.',
        expiredWaitlist: 'Inget bord blev ledigt från väntelistan i tid.',
        expiredRequest: 'Förfrågan bekräftades inte före den önskade tiden.',
      },
      bookAgain: 'Gör en ny bokning',
      lockedError: 'Bokningen har redan börjat eller passerat och kan inte längre ändras eller avbokas.',
    },
    welcomeDrinks: {
      title: 'Välkomstdrink',
      subtitle: 'Vill du förbeställa till bordet?',
      carousel: 'Drycker att förboka',
      add: 'Lägg till',
      decrease: 'Minska antal {0}',
      increase: 'Öka antal {0}',
      total: 'Totalt',
      payAmount: 'Beställ och betala {0}',
      reserveAmount: 'Beställ och betala {0}',
      continueToPayment: 'Fortsätt till betalning',
      paymentSoon: 'Betalning läggs till i ett senare steg.',
      paymentLoading: 'Startar betalning...',
      paymentConfirming: 'Bekräftar betalningen...',
      paymentStillPending:
        'Betalningen är inte bekräftad än. Den dyker upp på din bokning så snart den är klar – betala inte igen.',
      paymentSuccess: 'Betalningen är klar.',
      paymentFailed: 'Betalningen misslyckades. Försök igen.',
      emailReceipt: 'Mejla även kvittot till {0}',
      paymentCancelled: 'Betalningen avbröts. Välj ett betalsätt för att försöka igen.',
      paymentError: 'Kunde inte starta betalningen.',
      paymentMissingConfig: 'Betalning är inte konfigurerad.',
      paid: 'Betald',
      thankYou: 'Tack för din beställning!',
      servedAtTable:
        'Vi serverar välkomstdrinken vid ert bord när ni kommer, eller strax därefter.',
      viewReceipt: 'Visa kvitto',
      downloadReceipt: 'Ladda ner kvitto (PDF)',
      emailReceiptNow: 'Mejla kvittot',
      receiptEmailed: 'Kvittot är skickat till {0}.',
      receiptEmailTooSoon: 'Kvittot skickades nyss. Försök igen om en stund.',
      receiptEmailFailed: 'Det gick inte att mejla kvittot. Försök igen senare.',
      receiptDownloadFailed: 'Det gick inte att ladda ner kvittot. Försök igen.',
      opensInNewTab: '(öppnas i en ny flik)',
      refunded: 'Återbetald',
      refund: 'Återbetala',
      refunding: 'Återbetalar...',
      refundUntil: 'Du kan återbetala fram till {0} timmar före besöket.',
      refundClosed: 'Återbetalning är stängd från {0} timmar före besöket.',
      refundError: 'Kunde inte återbetala. Försök igen.',
      alreadyRefunded: 'Förbeställningen har redan återbetalats.',
      policyCapture: 'Valfritt · betalas nu och återbetalas fritt fram till {0} timmar före besöket · ångerrätt gäller inte',
      policyAuthorize: 'Valfritt · vi reserverar beloppet och debiterar det {0} timmar före besöket · ångerrätt gäller inte',
      reserved: 'Beloppet är reserverat',
      release: 'Avbryt betalning',
      releasing: 'Avbryter...',
      reservedUntil: 'Du debiteras {0} timmar före besöket. Avbryt fram till dess.',
      reservedClosed: 'Beloppet debiteras {0} timmar före besöket.',
      orderClosed:
        'Förbokning av välkomstdrinkar stänger {0} minuter före besöket.',
      idCheck:
        'Vi kontrollerar legitimation innan vi serverar alkohol. Kan du inte visa den serverar vi inte drycken.',
      ageGate: {
        question: 'Har du fyllt {0}?',
        rule: 'Drycker med alkohol visas bara för dig som fyllt {0} år. Legitimation kontrolleras vid servering.',
        confirm: 'Ja',
        decline: 'Nej',
        askAgain: 'Svara igen',
        locked: 'Dryck med alkohol, {0}+',
      },
    },
  },

  en: {
    booking: {
      nav: 'Booking Steps',
      guests: 'Step 1: Guests',
      date: 'Step 2: Date',
      time: 'Step 3: Time',
      summary: 'Booking Summary',
      edit: 'Edit Booking',
      view: 'View Booking on',
    },
    quickEditTabs: {
      seatings: 'Number of Guests',
      date: 'Date',
      time: 'Time',
    },
    counter: {
      group: {
        default: 'Select Number of Guests',
        kids: 'Select Number of Children',
        time: 'Select Time',
      },
      button: {
        decrease: 'Decrease Number of Guests',
        increase: 'Increase Number of Guests',
        decreaseKids: 'Decrease Number of Children',
        increaseKids: 'Increase Number of Children',
        decreaseTime: 'Select a previous time',
        increaseTime: 'Select a later time',
      },
      numberOfVisitors: {
        label: 'Number of Guests',
      },
      numberOfKids: {
        label: 'Number of Children',
      },
    },
    calendar: {
      navigation: 'Calendar Navigation',
      previousYear: 'Previous Year',
      nextYear: 'Next Year',
      previousMonth: 'Previous Month',
      nextMonth: 'Next Month',
      year: 'Year',
      month: 'Month',
      day: 'Day',
      selected: 'Selected Date',
      today: 'Today',
      disabled: 'Unavailable Date',
      event: 'Event Date',
      datePicker: 'Date Picker',
      tableCaption: 'Calendar table for',
    },
    timeSlots: {
      group: 'Times for {0}',
      selection: 'Time Selection',
      suggestion: 'Suggested Times',
    },
    datePicker: {
      dialog: 'Select Date',
    },
    timePicker: {
      dialog: 'Select Time',
    },
    segmentedControl: {
      default: 'Select Indoor or Outdoor Seating',
      indoor: 'Indoor',
      outdoor: 'Outdoor',
    },
    reservation: {
      header: {
        title: {
          waitlist: 'Waitlist',
        },
      },
    },
    relatedVenues: {
      title: 'Available Times at',
    },
    waitlist: {
      accept: {
        message: {
          close: 'Close Dialog',
        },
        availableSlots: 'Available Times',
      },
    },
    background: {
      decoration: 'Background Decoration',
    },
    reservationPhase: {
      label: {
        started: 'Ongoing',
        seated: 'Ongoing',
        completed: 'Past booking',
        cancelled: 'Cancelled',
        declined: 'Declined',
        expired: 'Expired',
      },
      notice: {
        started: 'Your booking time has started, so the booking can no longer be changed or cancelled here. Contact the restaurant if you need help.',
        seated: 'You have been seated – enjoy your visit! The booking can no longer be changed or cancelled.',
        completed: 'This booking has already taken place. We hope to see you again soon!',
        cancelled: 'This booking has been cancelled.',
        declined: 'Unfortunately, the restaurant was unable to accept this request.',
        expiredWaitlist: 'No table opened up from the waiting list in time.',
        expiredRequest: 'This request was not confirmed before the requested time.',
      },
      bookAgain: 'Make a new booking',
      lockedError: 'This booking has already started or ended and can no longer be changed or cancelled.',
    },
    welcomeDrinks: {
      title: 'Welcome drink',
      subtitle: 'Would you like to pre-order for your table?',
      carousel: 'Drinks available to preorder',
      add: 'Add',
      decrease: 'Fewer {0}',
      increase: 'More {0}',
      total: 'Total',
      payAmount: 'Order and pay {0}',
      reserveAmount: 'Order and pay {0}',
      continueToPayment: 'Continue to payment',
      paymentSoon: 'Payment will be added in a later step.',
      paymentLoading: 'Starting payment...',
      paymentConfirming: 'Confirming payment...',
      paymentStillPending:
        'Your payment isn’t confirmed yet. It will show on your booking as soon as it is – please don’t pay again.',
      paymentSuccess: 'Payment completed.',
      paymentFailed: 'Payment failed. Try again.',
      emailReceipt: 'Also email the receipt to {0}',
      paymentCancelled: 'Payment cancelled. Choose a payment method to try again.',
      paymentError: 'Could not start payment.',
      paymentMissingConfig: 'Payment is not configured.',
      paid: 'Paid',
      thankYou: 'Thank you for your order!',
      servedAtTable:
        'We’ll serve your welcome drinks at your table as you arrive, or shortly after.',
      viewReceipt: 'View receipt',
      downloadReceipt: 'Download receipt (PDF)',
      emailReceiptNow: 'Email receipt',
      receiptEmailed: 'The receipt is on its way to {0}.',
      receiptEmailTooSoon: 'The receipt was just sent. Try again in a minute.',
      receiptEmailFailed: 'The receipt could not be emailed. Try again later.',
      receiptDownloadFailed: 'The receipt could not be downloaded. Please try again.',
      opensInNewTab: '(opens in a new tab)',
      refunded: 'Refunded',
      refund: 'Refund',
      refunding: 'Refunding...',
      refundUntil: 'You can refund until {0} hours before your visit.',
      refundClosed: 'Refunds close {0} hours before your visit.',
      refundError: 'Could not refund. Please try again.',
      alreadyRefunded: 'This preorder has already been refunded.',
      policyCapture: 'Optional · paid now and fully refundable until {0} hours before your visit · no right of withdrawal',
      policyAuthorize: 'Optional · we reserve the amount and charge it {0} hours before your visit · no right of withdrawal',
      reserved: 'Amount reserved',
      release: 'Cancel payment',
      releasing: 'Cancelling...',
      reservedUntil: 'You’ll be charged {0} hours before your visit. Cancel until then.',
      reservedClosed: 'The amount will be charged {0} hours before your visit.',
      orderClosed:
        'Welcome drink pre-orders close {0} minutes before your visit.',
      idCheck:
        "We check ID before serving alcohol. If you can't show it, we can't serve the drink.",
      ageGate: {
        question: 'Are you {0} or older?',
        rule: 'Drinks with alcohol are only shown to guests aged {0} or over. ID is checked when serving.',
        confirm: 'Yes',
        decline: 'No',
        askAgain: 'Answer again',
        locked: 'Drink with alcohol, {0}+',
      },
    },
  },
  nb: {
    booking: {
      nav: 'Bestillingssteg',
      guests: 'Steg 1: Gjester',
      date: 'Steg 2: Dato',
      time: 'Steg 3: Tid',
      summary: 'Bestillingsoversikt',
      edit: 'Rediger bestilling',
      view: 'Vis bestilling på',
    },
    quickEditTabs: {
      seatings: 'Antall gjester',
      date: 'Dato',
      time: 'Tid',
    },
    counter: {
      group: {
        default: 'Velg antall gjester',
      },
      button: {
        decrease: 'Reduser antall gjester',
        increase: 'Øk antall gjester',
        decreaseKids: 'Reduser antall barn',
        increaseKids: 'Øk antall barn',
        decreaseTime: 'Reduser tid',
        increaseTime: 'Reduser tid',
      },
      numberOfVisitors: {
        label: 'Antall gjester',
      },
      numberOfKids: {
        label: 'Antall barn',
      },
    },
    calendar: {
      navigation: 'Kalendernavigasjon',
      previousYear: 'Forrige år',
      nextYear: 'Neste år',
      previousMonth: 'Forrige måned',
      nextMonth: 'Neste måned',
      year: 'År',
      month: 'Måned',
      day: 'Dag',
      selected: 'Valgt dato',
      today: 'I dag',
      disabled: 'Utilgjengelig dato',
      event: 'Arrangementdato',
      datePicker: 'Datovelger',
      tableCaption: 'Kalendertabell for',
    },
    timeSlots: {
      group: 'Tider for {0}',
      selection: 'Tidsvalg',
      suggestion: 'Foreslåtte tider',
    },
    datePicker: {
      dialog: 'Velg dato',
    },
    timePicker: {
      dialog: 'Velg tid',
    },
    segmentedControl: {
      default: 'Velg sitteplass inne eller ute',
      indoor: 'Innendørs',
      outdoor: 'Utendørs',
    },
    reservation: {
      header: {
        title: {
          waitlist: 'Venteliste',
        },
      },
    },
    relatedVenues: {
      title: 'Ledige tider på',
    },
    waitlist: {
      accept: {
        message: {
          close: 'Lukk dialogboks',
        },
        availableSlots: 'Ledige tider',
      },
    },
    background: {
      decoration: 'Bakgrunnsdekorasjon',
    },
    reservationPhase: {
      label: {
        started: 'Pågår',
        seated: 'Pågår',
        completed: 'Tidligere bestilling',
        cancelled: 'Avbestilt',
        declined: 'Avslått',
        expired: 'Utløpt',
      },
      notice: {
        started: 'Den bestilte tiden har startet, så bestillingen kan ikke lenger endres eller avbestilles her. Kontakt restauranten hvis du trenger hjelp.',
        seated: 'Du har fått bordet ditt – nyt besøket! Bestillingen kan ikke lenger endres eller avbestilles.',
        completed: 'Denne bestillingen har allerede funnet sted. Velkommen tilbake!',
        cancelled: 'Denne bestillingen er avbestilt.',
        declined: 'Restauranten kunne dessverre ikke ta imot denne forespørselen.',
        expiredWaitlist: 'Det ble ikke ledig noe bord fra ventelisten i tide.',
        expiredRequest: 'Forespørselen ble ikke bekreftet før ønsket tid.',
      },
      bookAgain: 'Gjør en ny bestilling',
      lockedError: 'Bestillingen har allerede startet eller er passert og kan ikke lenger endres eller avbestilles.',
    },
    welcomeDrinks: {
      title: 'Velkomstdrikk',
      subtitle: 'Vil du forhåndsbestille til bordet?',
      carousel: 'Drikke å forhåndsbestille',
      add: 'Legg til',
      decrease: 'Færre {0}',
      increase: 'Flere {0}',
      total: 'Totalt',
      payAmount: 'Bestill og betal {0}',
      reserveAmount: 'Bestill og betal {0}',
      continueToPayment: 'Fortsett til betaling',
      paymentSoon: 'Betaling legges til i et senere steg.',
      paymentLoading: 'Starter betaling...',
      paymentConfirming: 'Bekrefter betalingen...',
      paymentStillPending:
        'Betalingen er ikke bekreftet ennå. Den vises på bestillingen din så snart den er klar – ikke betal på nytt.',
      paymentSuccess: 'Betalingen er fullført.',
      paymentFailed: 'Betalingen mislyktes. Prøv igjen.',
      emailReceipt: 'Send også kvitteringen på e-post til {0}',
      paymentCancelled: 'Betalingen ble avbrutt. Velg en betalingsmåte for å prøve igjen.',
      paymentError: 'Kunne ikke starte betalingen.',
      paymentMissingConfig: 'Betaling er ikke konfigurert.',
      paid: 'Betalt',
      thankYou: 'Takk for bestillingen!',
      servedAtTable:
        'Vi serverer velkomstdrinken ved bordet når dere kommer, eller like etter.',
      viewReceipt: 'Vis kvittering',
      downloadReceipt: 'Last ned kvittering (PDF)',
      emailReceiptNow: 'Send kvitteringen på e-post',
      receiptEmailed: 'Kvitteringen er sendt til {0}.',
      receiptEmailTooSoon: 'Kvitteringen ble nettopp sendt. Prøv igjen om litt.',
      receiptEmailFailed: 'Kvitteringen kunne ikke sendes. Prøv igjen senere.',
      receiptDownloadFailed: 'Kvitteringen kunne ikke lastes ned. Prøv igjen.',
      opensInNewTab: '(åpnes i en ny fane)',
      refunded: 'Refundert',
      refund: 'Refunder',
      refunding: 'Refunderer...',
      refundUntil: 'Du kan refundere frem til {0} timer før besøket.',
      refundClosed: 'Refundering stenges {0} timer før besøket.',
      refundError: 'Kunne ikke refundere. Prøv igjen.',
      alreadyRefunded: 'Denne forhåndsbestillingen er allerede refundert.',
      policyCapture: 'Valgfritt · betales nå og refunderes fritt frem til {0} timer før besøket · angrerett gjelder ikke',
      policyAuthorize: 'Valgfritt · vi reserverer beløpet og belaster det {0} timer før besøket · angrerett gjelder ikke',
      reserved: 'Beløpet er reservert',
      release: 'Avbryt betaling',
      releasing: 'Avbryter...',
      reservedUntil: 'Du belastes {0} timer før besøket. Avbryt frem til da.',
      reservedClosed: 'Beløpet belastes {0} timer før besøket.',
      orderClosed:
        'Forhåndsbestilling av velkomstdrinker stenger {0} minutter før besøket.',
      idCheck:
        'Vi sjekker legitimasjon før vi serverer alkohol. Kan du ikke vise den, serverer vi ikke drikken.',
      ageGate: {
        question: 'Har du fylt {0}?',
        rule: 'Drikke med alkohol vises bare for deg som har fylt {0} år. Legitimasjon sjekkes ved servering.',
        confirm: 'Ja',
        decline: 'Nei',
        askAgain: 'Svar på nytt',
        locked: 'Drikke med alkohol, {0}+',
      },
    },
  },
  da: {
    booking: {
      nav: 'Bookingtrin',
      guests: 'Trin 1: Gæster',
      date: 'Trin 2: Dato',
      time: 'Trin 3: Tid',
      summary: 'Bookingoversigt',
      edit: 'Rediger booking',
      view: 'Vis booking på',
    },
    quickEditTabs: {
      seatings: 'Antal gæster',
      date: 'Dato',
      time: 'Tid',
    },
    counter: {
      group: {
        default: 'Vælg antal gæster',
        kids: 'Vælg antal børn',
        time: 'Vælg tid',
      },
      button: {
        decrease: 'Reducer antal gæster',
        increase: 'Forøg antal gæster',
        decreaseKids: 'Reducer antal børn',
        increaseKids: 'Forøg antal børn',
        decreaseTime: 'Vælg en tidligere tid',
        increaseTime: 'Vælg en senere tid',
      },
      numberOfVisitors: {
        label: 'Antal gæster',
      },
      numberOfKids: {
        label: 'Antal børn',
      },
    },
    calendar: {
      navigation: 'Kalendernavigation',
      previousYear: 'Forrige år',
      nextYear: 'Næste år',
      previousMonth: 'Forrige måned',
      nextMonth: 'Næste måned',
      year: 'År',
      month: 'Måned',
      day: 'Dag',
      selected: 'Valgt dato',
      today: 'I dag',
      disabled: 'Utilgængelig dato',
      event: 'Begivenhedsdato',
      datePicker: 'Datovælger',
      tableCaption: 'Kalendertabell for',
    },
    timeSlots: {
      group: 'Tider for {0}',
      selection: 'Tidsvalg',
      suggestion: 'Foreslåtte tider',
    },
    datePicker: {
      dialog: 'Vælg dato',
    },
    timePicker: {
      dialog: 'Vælg tid',
    },
    segmentedControl: {
      default: 'Vælg siddeplads inde eller ude',
      indoor: 'Indendørs',
      outdoor: 'Udendørs',
    },
    reservation: {
      header: {
        title: {
          waitlist: 'Venteliste',
        },
      },
    },
    relatedVenues: {
      title: 'Ledige tider på',
    },
    waitlist: {
      accept: {
        message: {
          close: 'Luk dialogboks',
        },
        availableSlots: 'Ledige tider',
      },
    },
    background: {
      decoration: 'Baggrundsdekoration',
    },
    reservationPhase: {
      label: {
        started: 'I gang',
        seated: 'I gang',
        completed: 'Tidligere booking',
        cancelled: 'Aflyst',
        declined: 'Afvist',
        expired: 'Udløbet',
      },
      notice: {
        started: 'Din bookede tid er begyndt, så bookingen kan ikke længere ændres eller aflyses her. Kontakt restauranten, hvis du har brug for hjælp.',
        seated: 'Du har fået dit bord – nyd besøget! Bookingen kan ikke længere ændres eller aflyses.',
        completed: 'Denne booking har allerede fundet sted. Velkommen tilbage!',
        cancelled: 'Denne booking er aflyst.',
        declined: 'Restauranten kunne desværre ikke imødekomme denne forespørgsel.',
        expiredWaitlist: 'Der blev ikke et bord ledigt fra ventelisten i tide.',
        expiredRequest: 'Forespørgslen blev ikke bekræftet inden det ønskede tidspunkt.',
      },
      bookAgain: 'Lav en ny booking',
      lockedError: 'Bookingen er allerede begyndt eller overstået og kan ikke længere ændres eller aflyses.',
    },
    welcomeDrinks: {
      title: 'Velkomstdrik',
      subtitle: 'Vil du forudbestille til bordet?',
      carousel: 'Drikkevarer at forudbestille',
      add: 'Tilføj',
      decrease: 'Færre {0}',
      increase: 'Flere {0}',
      total: 'I alt',
      payAmount: 'Bestil og betal {0}',
      reserveAmount: 'Bestil og betal {0}',
      continueToPayment: 'Fortsæt til betaling',
      paymentSoon: 'Betaling tilføjes i et senere trin.',
      paymentLoading: 'Starter betaling...',
      paymentConfirming: 'Bekræfter betalingen...',
      paymentStillPending:
        'Betalingen er ikke bekræftet endnu. Den vises på din booking, så snart den er klar – betal ikke igen.',
      paymentSuccess: 'Betalingen er gennemført.',
      paymentFailed: 'Betalingen mislykkedes. Prøv igen.',
      emailReceipt: 'Send også kvitteringen på e-mail til {0}',
      paymentCancelled: 'Betalingen blev afbrudt. Vælg en betalingsmetode for at prøve igen.',
      paymentError: 'Kunne ikke starte betalingen.',
      paymentMissingConfig: 'Betaling er ikke konfigureret.',
      paid: 'Betalt',
      thankYou: 'Tak for din bestilling!',
      servedAtTable:
        'Vi serverer velkomstdrinken ved jeres bord, når I kommer, eller kort efter.',
      viewReceipt: 'Vis kvittering',
      downloadReceipt: 'Download kvittering (PDF)',
      emailReceiptNow: 'Send kvitteringen på e-mail',
      receiptEmailed: 'Kvitteringen er sendt til {0}.',
      receiptEmailTooSoon: 'Kvitteringen blev lige sendt. Prøv igen om lidt.',
      receiptEmailFailed: 'Kvitteringen kunne ikke sendes. Prøv igen senere.',
      receiptDownloadFailed: 'Kvitteringen kunne ikke downloades. Prøv igen.',
      opensInNewTab: '(åbner i en ny fane)',
      refunded: 'Refunderet',
      refund: 'Refunder',
      refunding: 'Refunderer...',
      refundUntil: 'Du kan refundere indtil {0} timer før besøget.',
      refundClosed: 'Refundering lukker {0} timer før besøget.',
      refundError: 'Kunne ikke refundere. Prøv igen.',
      alreadyRefunded: 'Denne forudbestilling er allerede refunderet.',
      policyCapture: 'Valgfrit · betales nu og refunderes frit indtil {0} timer før besøget · fortrydelsesret gælder ikke',
      policyAuthorize: 'Valgfrit · vi reserverer beløbet og trækker det {0} timer før besøget · fortrydelsesret gælder ikke',
      reserved: 'Beløbet er reserveret',
      release: 'Annuller betaling',
      releasing: 'Annullerer...',
      reservedUntil: 'Du bliver debiteret {0} timer før besøget. Annuller indtil da.',
      reservedClosed: 'Beløbet debiteres {0} timer før besøget.',
      orderClosed:
        'Forudbestilling af velkomstdrinks lukker {0} minutter før besøget.',
      idCheck:
        'Vi tjekker legitimation, før vi serverer alkohol. Kan du ikke vise den, serverer vi ikke drinken.',
      ageGate: {
        question: 'Er du fyldt {0}?',
        rule: 'Drikkevarer med alkohol vises kun for dig, der er fyldt {0} år. Legitimation tjekkes ved servering.',
        confirm: 'Ja',
        decline: 'Nej',
        askAgain: 'Svar igen',
        locked: 'Drik med alkohol, {0}+',
      },
    },
  },
  de: {
    booking: {
      nav: 'Buchungsschritte',
      guests: 'Schritt 1: Gäste',
      date: 'Schritt 2: Datum',
      time: 'Schritt 3: Uhrzeit',
      summary: 'Buchungsübersicht',
      edit: 'Buchung bearbeiten',
      view: 'Buchung ansehen',
    },
    quickEditTabs: {
      seatings: 'Anzahl der Gäste',
      date: 'Datum',
      time: 'Uhrzeit',
    },
    counter: {
      group: {
        default: 'Anzahl der Gäste auswählen',
        kids: 'Anzahl der Kinder auswählen',
        time: 'Uhrzeit auswählen',
      },
      button: {
        decrease: 'Anzahl der Gäste verringern',
        increase: 'Anzahl der Gäste erhöhen',
        decreaseKids: 'Anzahl der Kinder verringern',
        increaseKids: 'Anzahl der Kinder erhöhen',
        decreaseTime: 'Vorherige Uhrzeit auswählen',
        increaseTime: 'Nächste Uhrzeit auswählen',
      },
      numberOfVisitors: {
        label: 'Anzahl der Gäste',
      },
      numberOfKids: {
        label: 'Anzahl der Kinder',
      },
    },
    calendar: {
      navigation: 'Kalendernavigation',
      previousYear: 'Vorheriges Jahr',
      nextYear: 'Nächstes Jahr',
      previousMonth: 'Vorheriger Monat',
      nextMonth: 'Nächster Monat',
      year: 'Jahr',
      month: 'Monat',
      day: 'Tag',
      selected: 'Ausgewähltes Datum',
      today: 'Heute',
      disabled: 'Nicht verfügbares Datum',
      event: 'Veranstaltungsdatum',
      datePicker: 'Datumsauswahl',
      tableCaption: 'Kalendertabell for',
    },
    timeSlots: {
      group: 'Zeiten für {0}',
      selection: 'Zeitauswahl',
      suggestion: 'Vorgeschlagene Zeiten',
    },
    datePicker: {
      dialog: 'Datum auswählen',
    },
    timePicker: {
      dialog: 'Uhrzeit auswählen',
    },
    segmentedControl: {
      default: 'Sitzplatz innen oder außen wählen',
      indoor: 'Innen',
      outdoor: 'Außen',
    },
    reservation: {
      header: {
        title: {
          waitlist: 'Warteliste',
        },
      },
    },
    relatedVenues: {
      title: 'Verfügbare Zeiten bei',
    },
    waitlist: {
      accept: {
        message: {
          close: 'Dialog schließen',
        },
        availableSlots: 'Verfügbare Zeiten',
      },
    },
    background: {
      decoration: 'Hintergrunddekoration',
    },
    reservationPhase: {
      label: {
        started: 'Läuft',
        seated: 'Läuft',
        completed: 'Abgeschlossen',
        cancelled: 'Storniert',
        declined: 'Abgelehnt',
        expired: 'Abgelaufen',
      },
      notice: {
        started: 'Deine reservierte Zeit hat begonnen, daher kann die Reservierung hier nicht mehr geändert oder storniert werden. Wende dich an das Restaurant, wenn du Hilfe brauchst.',
        seated: 'Du hast deinen Tisch – genieß deinen Besuch! Die Reservierung kann nicht mehr geändert oder storniert werden.',
        completed: 'Diese Reservierung hat bereits stattgefunden. Wir freuen uns auf deinen nächsten Besuch!',
        cancelled: 'Diese Reservierung wurde storniert.',
        declined: 'Das Restaurant konnte diese Anfrage leider nicht annehmen.',
        expiredWaitlist: 'Über die Warteliste ist nicht rechtzeitig ein Tisch frei geworden.',
        expiredRequest: 'Diese Anfrage wurde vor der gewünschten Zeit nicht bestätigt.',
      },
      bookAgain: 'Neue Reservierung',
      lockedError: 'Die Reservierung hat bereits begonnen oder ist vorbei und kann nicht mehr geändert oder storniert werden.',
    },
    welcomeDrinks: {
      title: 'Willkommensgetränk',
      subtitle: 'Möchtest du für deinen Tisch vorbestellen?',
      carousel: 'Getränke zum Vorbestellen',
      add: 'Hinzufügen',
      decrease: 'Weniger {0}',
      increase: 'Mehr {0}',
      total: 'Gesamt',
      payAmount: 'Zahlungspflichtig bestellen · {0}',
      reserveAmount: 'Zahlungspflichtig bestellen · {0}',
      continueToPayment: 'Weiter zur Zahlung',
      paymentSoon: 'Die Zahlung wird in einem späteren Schritt hinzugefügt.',
      paymentLoading: 'Zahlung wird gestartet...',
      paymentConfirming: 'Zahlung wird bestätigt...',
      paymentStillPending:
        'Deine Zahlung ist noch nicht bestätigt. Sie erscheint in deiner Buchung, sobald sie abgeschlossen ist – bitte nicht erneut bezahlen.',
      paymentSuccess: 'Zahlung abgeschlossen.',
      paymentFailed: 'Zahlung fehlgeschlagen. Bitte erneut versuchen.',
      emailReceipt: 'Quittung zusätzlich per E-Mail an {0} senden',
      paymentCancelled: 'Zahlung abgebrochen. Wähle eine Zahlungsart, um es erneut zu versuchen.',
      paymentError: 'Zahlung konnte nicht gestartet werden.',
      paymentMissingConfig: 'Zahlung ist nicht konfiguriert.',
      paid: 'Bezahlt',
      thankYou: 'Danke für deine Bestellung!',
      servedAtTable:
        'Wir servieren euch den Willkommensdrink am Tisch, sobald ihr ankommt, oder kurz danach.',
      viewReceipt: 'Beleg anzeigen',
      downloadReceipt: 'Quittung herunterladen (PDF)',
      emailReceiptNow: 'Quittung per E-Mail senden',
      receiptEmailed: 'Die Quittung ist unterwegs an {0}.',
      receiptEmailTooSoon: 'Die Quittung wurde gerade gesendet. Versuche es gleich noch einmal.',
      receiptEmailFailed: 'Die Quittung konnte nicht gesendet werden. Versuche es später noch einmal.',
      receiptDownloadFailed: 'Die Quittung konnte nicht heruntergeladen werden. Versuche es noch einmal.',
      opensInNewTab: '(öffnet in einem neuen Tab)',
      refunded: 'Erstattet',
      refund: 'Erstatten',
      refunding: 'Wird erstattet...',
      refundUntil: 'Du kannst bis {0} Stunden vor dem Besuch erstatten.',
      refundClosed: 'Erstattungen enden {0} Stunden vor dem Besuch.',
      refundError: 'Erstattung fehlgeschlagen. Bitte erneut versuchen.',
      alreadyRefunded: 'Diese Vorbestellung wurde bereits erstattet.',
      policyCapture: 'Optional · jetzt bezahlt und bis {0} Stunden vor dem Besuch voll erstattbar · kein Widerrufsrecht',
      policyAuthorize: 'Optional · wir reservieren den Betrag und buchen ihn {0} Stunden vor dem Besuch ab · kein Widerrufsrecht',
      reserved: 'Betrag reserviert',
      release: 'Zahlung stornieren',
      releasing: 'Wird storniert...',
      reservedUntil: 'Abbuchung {0} Stunden vor dem Besuch. Bis dahin stornieren.',
      reservedClosed: 'Der Betrag wird {0} Stunden vor dem Besuch abgebucht.',
      orderClosed:
        'Willkommensgetränke kannst du bis {0} Minuten vor dem Besuch vorbestellen.',
      idCheck:
        'Bevor wir Alkohol servieren, kontrollieren wir den Ausweis. Kannst du keinen zeigen, dürfen wir das Getränk nicht servieren.',
      ageGate: {
        question: 'Bist du {0} oder älter?',
        rule: 'Getränke mit Alkohol zeigen wir nur Gästen ab {0} Jahren. Beim Servieren kontrollieren wir den Ausweis.',
        confirm: 'Ja',
        decline: 'Nein',
        askAgain: 'Erneut antworten',
        locked: 'Getränk mit Alkohol, ab {0}',
      },
    },
  },
  fi: {
    booking: {
      nav: 'Varausvaiheet',
      guests: 'Vaihe 1: Vieraat',
      date: 'Vaihe 2: Päivämäärä',
      time: 'Vaihe 3: Aika',
      summary: 'Varausyhteenveto',
      edit: 'Muokkaa varausta',
      view: 'Katso varaus',
    },
    quickEditTabs: {
      seatings: 'Vieraiden määrä',
      date: 'Päivämäärä',
      time: 'Aika',
    },
    counter: {
      group: {
        default: 'Valitse vieraiden määrä',
        kids: 'Valitse lasten määrä',
        time: 'Valitse aika',
      },
      button: {
        decrease: 'Vähennä vieraiden määrää',
        increase: 'Lisää vieraiden määrää',
        decreaseKids: 'Vähennä lasten määrää',
        increaseKids: 'Lisää lasten määrää',
        decreaseTime: 'Valitse aikaisempi aika',
        increaseTime: 'Valitse myöhempi aika',
      },
      numberOfVisitors: {
        label: 'Vieraiden määrä',
      },
      numberOfKids: {
        label: 'Lasten määrä',
      },
    },
    calendar: {
      navigation: 'Kalenterinavigointi',
      previousYear: 'Edellinen vuosi',
      nextYear: 'Seuraava vuosi',
      previousMonth: 'Edellinen kuukausi',
      nextMonth: 'Seuraava kuukausi',
      year: 'Vuosi',
      month: 'Kuukausi',
      day: 'Päivä',
      selected: 'Valittu päivämäärä',
      today: 'Tänään',
      disabled: 'Ei saatavilla oleva päivämäärä',
      event: 'Tapahtumapäivä',
      datePicker: 'Päivämäärän valitsin',
      tableCaption: 'Kalenteritaulukko',
    },
    timeSlots: {
      group: 'Ajat kohteelle {0}',
      selection: 'Ajan valinta',
      suggestion: 'Ehdotetut ajat',
    },
    datePicker: {
      dialog: 'Valitse päivämäärä',
    },
    timePicker: {
      dialog: 'Valitse aika',
    },
    segmentedControl: {
      default: 'Valitse sisä- tai ulkopaikka',
      indoor: 'Sisällä',
      outdoor: 'Ulkona',
    },
    reservation: {
      header: {
        title: {
          waitlist: 'Jonotuslista',
        },
      },
    },
    relatedVenues: {
      title: 'Vapaat ajat kohteessa',
    },
    waitlist: {
      accept: {
        message: {
          close: 'Sulje valintaikkuna',
        },
        availableSlots: 'Vapaat ajat',
      },
    },
    background: {
      decoration: 'Taustakoriste',
    },
    reservationPhase: {
      label: {
        started: 'Käynnissä',
        seated: 'Käynnissä',
        completed: 'Mennyt varaus',
        cancelled: 'Peruttu',
        declined: 'Hylätty',
        expired: 'Vanhentunut',
      },
      notice: {
        started: 'Varattu aikasi on alkanut, joten varausta ei voi enää muuttaa tai perua täällä. Ota yhteyttä ravintolaan, jos tarvitset apua.',
        seated: 'Olet saanut pöytäsi – nauti käynnistä! Varausta ei voi enää muuttaa tai perua.',
        completed: 'Tämä varaus on jo toteutunut. Tervetuloa uudelleen!',
        cancelled: 'Tämä varaus on peruttu.',
        declined: 'Ravintola ei valitettavasti voinut hyväksyä tätä pyyntöä.',
        expiredWaitlist: 'Jonotuslistalta ei vapautunut pöytää ajoissa.',
        expiredRequest: 'Pyyntöä ei vahvistettu ennen toivottua aikaa.',
      },
      bookAgain: 'Tee uusi varaus',
      lockedError: 'Varaus on jo alkanut tai päättynyt, eikä sitä voi enää muuttaa tai perua.',
    },
    welcomeDrinks: {
      title: 'Tervetuliaismalja',
      subtitle: 'Haluatko tilata pöytään etukäteen?',
      carousel: 'Ennakkoon tilattavat juomat',
      add: 'Lisää',
      decrease: 'Vähemmän {0}',
      increase: 'Enemmän {0}',
      total: 'Yhteensä',
      payAmount: 'Tilaa ja maksa {0}',
      reserveAmount: 'Tilaa ja maksa {0}',
      continueToPayment: 'Jatka maksuun',
      paymentSoon: 'Maksu lisätään myöhemmässä vaiheessa.',
      paymentLoading: 'Maksua aloitetaan...',
      paymentConfirming: 'Maksua vahvistetaan...',
      paymentStillPending:
        'Maksuasi ei ole vielä vahvistettu. Se näkyy varauksessasi heti kun se on valmis – älä maksa uudelleen.',
      paymentSuccess: 'Maksu on valmis.',
      paymentFailed: 'Maksu epäonnistui. Yritä uudelleen.',
      emailReceipt: 'Lähetä kuitti myös sähköpostiin {0}',
      paymentCancelled: 'Maksu peruutettiin. Valitse maksutapa yrittääksesi uudelleen.',
      paymentError: 'Maksua ei voitu aloittaa.',
      paymentMissingConfig: 'Maksua ei ole määritetty.',
      paid: 'Maksettu',
      thankYou: 'Kiitos tilauksestasi!',
      servedAtTable:
        'Tarjoilemme tervetulojuomat pöytäänne saapuessanne tai pian sen jälkeen.',
      viewReceipt: 'Näytä kuitti',
      downloadReceipt: 'Lataa kuitti (PDF)',
      emailReceiptNow: 'Lähetä kuitti sähköpostiin',
      receiptEmailed: 'Kuitti on lähetetty osoitteeseen {0}.',
      receiptEmailTooSoon: 'Kuitti lähetettiin juuri. Yritä hetken päästä uudelleen.',
      receiptEmailFailed: 'Kuittia ei voitu lähettää. Yritä myöhemmin uudelleen.',
      receiptDownloadFailed: 'Kuittia ei voitu ladata. Yritä uudelleen.',
      opensInNewTab: '(avautuu uuteen välilehteen)',
      refunded: 'Hyvitetty',
      refund: 'Hyvitä',
      refunding: 'Hyvitetään...',
      refundUntil: 'Voit hyvittää ostoksen {0} tuntia ennen vierailua.',
      refundClosed: 'Hyvitys sulkeutuu {0} tuntia ennen vierailua.',
      refundError: 'Hyvitys epäonnistui. Yritä uudelleen.',
      alreadyRefunded: 'Tämä ennakkotilaus on jo hyvitetty.',
      policyCapture: 'Valinnainen · maksetaan nyt ja palautetaan täysin {0} tuntia ennen vierailua asti · ei peruuttamisoikeutta',
      policyAuthorize: 'Valinnainen · varaamme summan ja veloitamme sen {0} tuntia ennen vierailua · ei peruuttamisoikeutta',
      reserved: 'Summa varattu',
      release: 'Peruuta maksu',
      releasing: 'Perutaan...',
      reservedUntil: 'Veloitus {0} tuntia ennen vierailua. Peru siihen asti.',
      reservedClosed: 'Summa veloitetaan {0} tuntia ennen vierailua.',
      orderClosed:
        'Tervetulojuomien ennakkotilaus sulkeutuu {0} minuuttia ennen käyntiä.',
      idCheck:
        'Tarkistamme henkilöllisyyden ennen alkoholin tarjoilua. Jos et voi näyttää henkilöllisyystodistusta, emme tarjoile juomaa.',
      ageGate: {
        question: 'Oletko täyttänyt {0} vuotta?',
        rule: 'Alkoholijuomat näytetään vain {0} vuotta täyttäneille. Henkilöllisyys tarkistetaan tarjoilun yhteydessä.',
        confirm: 'Kyllä',
        decline: 'En',
        askAgain: 'Vastaa uudelleen',
        locked: 'Alkoholijuoma, {0}+',
      },
    },
  },
} as const;

export type Language = keyof typeof labels;
export type LabelKey = keyof typeof labels.en.booking;

// Helper type to get nested path types
type NestedPaths<T> = T extends object
  ? {
      [K in keyof T]: K extends string
        ? T[K] extends object
          ? `${K}.${NestedPaths<T[K]>}`
          : K
        : never;
    }[keyof T]
  : never;

export type LabelPath = NestedPaths<typeof labels.en>;
